import axios from "axios";
import router from "../router";
import { hasOwnProperty, storageClear } from "../utils/lib";

const fetch = axios.create({
    baseURL: "https://api.school-mom.kr/service",
    headers: {
        "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
    }
});

fetch.interceptors.request.use(
    function(config) {
        // pc version default setting
        config.params = { ...config.params, source: "pc" };
        return config;
    },
    function(error) {
        return Promise.reject(error);
    }
);

fetch.interceptors.response.use(
    function(response) {
        const { data } = response;

        if (hasOwnProperty(data, "resultCode")) {
            // pure server error
            if (data.resultCode >= 400 && data.resultCode < 500) {
                const lowerMessage = data.message.toLowerCase();
                const message =
                    hasOwnProperty(data, "message") && Errors[lowerMessage]
                        ? Errors[lowerMessage]
                        : "알 수 없는 에러 형태";

                throw new Error(message);
            }

            // message errror
            // 10003은 보통 empty 관련 오류이다.
            // 10005는 구독없는 겨웅
            if (data.resultCode > 10001 && data.resultCode !== 10003 && data.resultCode !== 10005) {
                if (!hasOwnProperty(data, "message")) throw new Error("알 수 없는 오류");

                const lowerMessage = data.message.toLowerCase();

                if (lowerMessage === "not authorized.") {
                    // 토큰 상실시 storage를 초기화 한다.
                    storageClear();
                    router.push("/auth");
                }

                const message =
                    hasOwnProperty(data, "message") && Errors[lowerMessage] ? Errors[lowerMessage] : data.message;

                throw new Error(message);
            }

            return response;
        }

        return response;
    },
    function(error) {
        const errorMessage = error.message.toLowerCase();
        const message = Errors[errorMessage] ? Errors[errorMessage] : "알 수 없는 오류발생";
        return Promise.reject(message);
    }
);

const Errors = {
    "parameter 'token' is empty.": "회원정보가 유효하지 않습니다.",
    "parameter 'phonenumber' is empty.": "핸드폰 번호를 입력해주세요.",
    "parameter 'password' is empty.": "비밀번호를 입력해주세요.",
    "not authorized.": "장시간 사용하지 않았거나, 다른 PC에서 로그인하여 로그아웃되었습니다.",
    "network error": "서버연결이 불안정합니다. 잠시후 시도해주세요.",
    "매칭된 유저를 찾을 수 없습니다.": "아이디 또는 비빌번호를 확인해주세요."
};

export default fetch;
